import { ethers } from "ethers";


const REACT_APP_CURRENCIES_POPCORN = process.env.REACT_APP_CURRENCIES_POPCORN;
console.log(`process.env.REACT_APP_CONTRACT_SALE = ${REACT_APP_CURRENCIES_POPCORN}`);

export const currencies = {
  KLAY: ethers.constants.AddressZero,
  POPCORN: REACT_APP_CURRENCIES_POPCORN,//"0x6a6184283af9f62da739f8b309c5fca61e2f1400",

};

export const currencyById = (currencyId) => {
  const currencyOrder = ["KLAY","TOKKI", "POPCORN", "POPCORN"];
  return currencies[currencyOrder[currencyId - 1]];
};
